import React from 'react'
import Header from '../component/Header'
import Donate from '../component/Donate'
import BottomBar from '../component/BottomBar'
import { Link } from 'react-router-dom'
import { FaAngleRight } from 'react-icons/fa6'
import './learn.css'
import { Helmet } from 'react-helmet-async'

function Learn() {
  return (
    <>
        <Helmet>
            <title>Learn-Share | The Lord Nations Foundation</title>
            <meta name="description" content="Explore inspiring stories, insights, and educational resources from The Lord Nations Foundation. Learn, share, and be a part of our mission to create positive change." />
        </Helmet>

        <div className='home' >
            <Header/>
            <div className='about_head_spacer'></div>
            <div className='learn_banner' >
                <div className='homebanner_overlay'>
                    <div className='homebanner_container'>
                        <div className='homebanner_text' >
                            <div className='donatenow_banner_label' >
                                <h3>LEARN & SHARE</h3>
                            </div>
                        </div>

                        <div className='danate_desk'>
                            <Donate/>
                        </div>
                    </div>
                </div>
            </div>

            <div className='danate_mob'>
            <Donate/>
            </div>
            
            <div className='about_sub' >
                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h1>Make a Difference Today</h1>
                </div>

                <div className='learn_container'>
                    <div className='learn_container_fstbox'>
                        <div className='learn_container_fstbox_img'></div>
                        <div className='learn_container_fstbox_text' >
                            <h3>Understanding the Challenges</h3>
                            <p>
                                Millions of people around the world struggle with basic needs such as food, shelter, education, and healthcare. Poverty, unemployment, and social inequalities make it difficult for many individuals and families to break the cycle of hardship ...
                            </p>
                            <Link className='learn_links' >
                                <h3>READ MORE</h3>
                                <FaAngleRight/>
                            </Link>
                        </div>
                    </div>

                    <div className='learn_container_secbox' >
                        <div className='learn_container_fstbox_texts' >
                            <h3>Statistics & Data</h3>
                            <small>To understand the scale of these issues, here are some eye-opening facts:</small>
                            <p>• Over 700 million people worldwide live in extreme poverty, surviving on less than $2.15 per day.</p>
                            <Link className='learn_links' >
                                <h3>READ MORE</h3>
                                <FaAngleRight/>
                            </Link>
                        </div>
                        <div className='learn_container_fstbox_texts' >
                            <h3>Personal Stories & Testimonials</h3>
                            <p>
                                I never imagined I would be homeless. After losing my job, I struggled to provide for my two children. Thanks to the support of generous donors, we found temporary shelter and access to job training ...
                            </p>
                            <Link className='learn_links' >
                                <h3>READ MORE</h3>
                                <FaAngleRight/>
                            </Link>
                        </div>
                        <div className='learn_container_fstbox_texts' >
                            <h3>How Support Helps</h3>
                            <small>Every contribution—big or small—has the power to create change:</small>
                            <p>• Donations provide food, clothing, and medical assistance to those in need.</p>
                            <p>• Volunteering helps communities receive hands-on support, mentorship, and education.</p>
                            <Link className='learn_links' >
                                <h3>READ MORE</h3>
                                <FaAngleRight/>
                            </Link>
                        </div>
                    </div>
                </div>
                
                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h1>Spread the Word & Take Action</h1>
                </div>
                
                <div className='learn_bars' >
                    <div className='learn_bars_img3'></div>
                    <div className='learn_bars_write_ups' >
                        <h1>Success Stories: The Journey Begins</h1>
                        <p>
                            Every great movement starts with a single step, and though we are just beginning our journey, the impact has already started to take shape. At The Lord Nations Foundation, we believe that even small acts of kindness can spark life-changing transformations.
                        </p>
                        <p>
                            “Education is a right, not a privilege. Join us in providing scholarships for underprivileged children. #EducationForAll”
                        </p>
                    </div>
                </div>
                
                <div className='learn_bars' >
                    <div className='learn_bars_img'></div>
                    <div className='learn_bars_write_ups' >
                        <h1>Social Media Toolkit</h1>
                        <small>Raise awareness by sharing these key messages with your network:</small>
                        <p>
                            “Did you know over 9 million people die from hunger every year? Let's make a change! Support food relief programs today. #EndHunger #MakeADifference”
                        </p>
                        <p>
                            “Education is a right, not a privilege. Join us in providing scholarships for underprivileged children. #EducationForAll”
                        </p>
                    </div>
                </div>
                
                <div className='learn_bars' >
                    <div className='learn_bars_img2'></div>
                    <div className='learn_bars_write_ups' >
                        <h1>Invite a Friend</h1>
                        <p>
                            Inspire others to get involved! Share this page with friends and encourage them to donate, volunteer, or advocate for change.
                        </p>
                        <h3>Why Share?</h3>
                        <p>
                            Many people want to help but don’t know where to start. By sharing this page, you’re giving them an opportunity to make a difference—whether through donations, volunteering, or simply spreading awareness. Every new supporter strengthens the mission and brings us closer to eradicating poverty, homelessness, and hunger.
                        </p>
                    </div>
                </div>
            </div>
            
            <BottomBar/>
        </div>
    </>
  )
}

export default Learn